import { tv } from "../foundations/cn.js";
import { TYPE_ROLES, type TypeRoleName } from "../foundations/presets.js";

const FAMILY_CLASSES = {
  body: "font-body",
  display: "font-display-role",
  mono: "font-mono tabular-nums",
} as const;

/** Each role's size, weight, tracking and family, keyed by role. Classes are complete literals. */
const VARIANT_CLASSES = {
  "display-hero": "text-display-hero",
  "display-band": "text-display-band",
  "display-xl1": "text-display-xl1",
  "display-xl2": "text-display-xl2",
  "display-xl3": "text-display-xl3",
  "display-xl4": "text-display-xl4",
  "heading-h1": "text-heading-h1",
  "heading-h2": "text-heading-h2",
  "heading-h3": "text-heading-h3",
  "body-b1": "text-body-b1",
  "body-b1-strong": "text-body-b1-strong",
  "body-b2": "text-body-b2",
  "body-b2-strong": "text-body-b2-strong",
  "body-b3": "text-body-b3",
  "body-b3-strong": "text-body-b3-strong",
  "caption-eyebrow": "text-caption-eyebrow uppercase",
  "mono-price-l": "text-mono-price-l",
  "mono-price": "text-mono-price",
  "mono-meta": "text-mono-meta",
} as const satisfies Record<TypeRoleName, string>;

const variant = Object.fromEntries(
  Object.entries(VARIANT_CLASSES).map(([role, classes]) => [
    role,
    `${classes} ${FAMILY_CLASSES[TYPE_ROLES[role as TypeRoleName].family]}`,
  ]),
) as Record<TypeRoleName, string>;

/** Text styles, usable on any element (`<label className={textStyles({ variant })}>`). */
export const textStyles = tv({
  base: "",
  variants: {
    variant,
    tone: {
      inherit: "",
      primary: "text-text-primary",
      secondary: "text-text-secondary",
      tertiary: "text-text-tertiary",
      disabled: "text-text-disabled",
      accent: "text-accent-text",
      highlight: "text-accent-highlight",
      success: "text-status-success",
      warning: "text-status-warning",
      danger: "text-status-danger",
      "on-accent": "text-text-on-accent",
    },
  },
  defaultVariants: { variant: "body-b1", tone: "inherit" },
});
